import T from '../types';

export default function resetSearchData(cancelled = false) {
  return {
    type: T.GET_SEARCH_DATA_RESET,
    cancelled,
  };
}
